/* eslint-disable */
import makeAPIRequest from "../../services/makeRequest";
import config from "../../config";

async function markComparisonDone(accessToken, body) {
  const API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/officernd/mark-done`;

  const response = await makeAPIRequest(API_ENDPOINT, "POST", body, accessToken);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default markComparisonDone;
